export default "__VITE_ASSET__BsLcz9SX__"